import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="features text-center">
      <div className="container">
        <div className="col section-title">
          <h2>{props.title}</h2>
          <p>{props.subTitle}</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-6 col-md-4 mb-4">
                  {" "}
                  <i className={`${d.icon} transition-eio`}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
